module.exports = __webpack_public_path__ + "static/media/frizo-choose-image-source.d7348072.png";